export const strings = {
  english: {
    password: 'The password entered was not recognized, or it may have expired. Please try again or reset your password using the link to the right.',
    account: 'No account has been found for this email address. Please check your entry and try again.',
    deactivateEntitlement: 'You have unlinked all devices from your Entitlement',
  },

  japan: {
    password: 'ご入力いただいたパスワードは登録内容に合致しないか、期限切れとなった可能性があります。再度お試しいただくか、右のリンクからパスワードをリセットしてください。',
    account: 'このEメールアドレスは登録されていません。入力内容を確認し、再度ログインをお試しください。',
    deactivateEntitlement: '全てのデバイスのリンクが解除されました',
  },
};
